import { createContext } from 'react'
import { validateEmail, validateFirstOrLast } from '../../helpers/misc'

const GiftCardContext = createContext()

export const giftCardState = {
  giftOption: 'gift-card',
  markets: [],
  giftCardPrice: null,
  giftCardPriceError: false,
  occasion: '',
  occasionError: false,
  personalMessage: '',
  recipientFirst: '',
  recipientFirstError: false,
  recipientLast: '',
  recipientLastError: false,
  recipientEmail: '',
  recipientEmailError: false,
  deliveryMethod: '',
  deliveryMethodError: false,
  priceData: [
    { custom: false, price: 60, suggestedUse: 'One Blowout' },
    { custom: false, price: 90, suggestedUse: 'One Makeup Application' },
    { custom: false, price: 120, suggestedUse: 'Two Blowouts' },
    { custom: false, price: 150, suggestedUse: 'One Blowout + One Makeup Application' }
  ],
  occasionData: ['Holidays', 'Birthday', 'Anniversary', 'Other'],
  deliveryDate: new Date(),
  deliveryDateUpdated: false,
  deliveryDateError: false,
  groups: null,
  selectedGroup: null,
  selectedProduct: null,
  selectedProductError: false,
  giftCardObject: null,
  giftCardObjectError: false,
}

export const giftCardReducer = (state, action) => {
  switch (action.type) {
    case 'SET_GIFT_OPTION':
      return {
        ...state,
        giftOption: action.option
      }
    case 'SET_GIFT_CARD_PRICE':
      return {
        ...state,
        giftCardPrice: action.price,
        giftCardPriceError: false
      }
    case 'SET_CUSTOM_PRICE':
      return {
        ...state,
        giftCardPrice: {
          ...state.giftCardPrice,
          price: Number.parseFloat(action.price)
        }
      }
    case 'SET_GIFT_CARD_OCCASION':
      return {
        ...state,
        occasion: action.occasion,
        occasionError: false
      }
    case 'EDIT_PERSONAL_MESSAGE':
      return {
        ...state,
        personalMessage: action.personalMessage
      }
    case 'EDIT_RECIPIENT_INFO':
      if (state[`${action.field}Error`]) {
        return {
          ...state,
          [action.field]: action.text,
          [`${action.field}Error`]:
            action.field === 'recipientEmail'
              ? validateEmail(action.text)
                ? false
                : true
              : validateFirstOrLast(action.text)
                ? false
                : true
        }
      }
      return {
        ...state,
        [action.field]: action.text
      }
    case 'SET_DELIVERY_METHOD':
      return {
        ...state,
        deliveryMethod: action.deliveryMethod,
        deliveryMethodError: false
      }
    case 'SET_DELIVERY_DATE':
      return {
        ...state,
        deliveryDate: action.date,
        deliveryDateUpdated: true,
        deliveryDateError: false
      }
    case 'SET_GROUPS':
      return {
        ...state,
        groups: action.groups
      }
    case 'SET_SELECTED_GROUP':
      return {
        ...state,
        selectedGroup: action.group
      }
    case 'SET_SELECTED_PRODUCT':
      return {
        ...state,
        selectedProduct: action.package,
        selectedProductError: false
      }
    case 'SET_GIFT_CARD':
      return {
        ...state,
        giftCardObject: action.giftCard
      }
    case 'SET_ERRORS': {
      const { fields } = action
      fields.forEach(f => {
        state[f] = true
      })
      return { ...state }
    }
    case 'RESET_STATE':
      return { ...state, ...action.state }
    default:
      return state
  }
}

export default GiftCardContext
